export default __webpack_public_path__ + "static/media/working.8f83b3e9.png";